export default __webpack_public_path__ + "static/media/38_4_3.c2e134d6.png";